/**
 * StartDesignModal Component - Created by eduardoquintero on 19/10/20.
 */
import * as React from 'react'
import Modal from 'antd/lib/modal'
import {
  // Title,
  Card,
  CardTitle,
  // DesignsCardsContainer,
  Item,
  List,
  // BannerBack,
  // Banner,
  // FoldContent,
  // UnfoldContainer,
  // MobileCard,
  ButtonWrapper,
  Button,
  ColorWheel,
  // MobileContainer,
  // CloseIcon,
  DescriptionDiv,
  // AdditionalDiv,
  // OrText,
  // BottomDescription,
  // RequestMore,
  InlineContainer
} from './styledComponents'
// import closeIcon from '../../assets/cancel-button.svg'
import colorWheel from '../../assets/Colorwheel.svg'
import DesignCenterBanner from '../../assets/start_design_lab.jpg'
import ProDesignBanner from '../../assets/start_pro_design.jpg'
// import UnfoldList from '../UnfoldList'
// import CustomModal from '../Common/JakrooModal'
// import SimpleLi from '../SimpleLi'
import zenscroll from 'zenscroll'

interface Props {
  visible?: boolean
  open: boolean
  hideCustomize?: boolean
  goToCustomize: () => void
  goToProDesign: () => void
  openForm: () => void
  onClose: () => void
}

const proDesignMessages = [
  'dedicatedAccount'
]

export class StartDesignModal extends React.Component<Props, {}> {
  state = {
    designCardFolded: true,
    proDesignCardFolded: true,
    animationInProgress: false,
    isMobile: false
  }
  private btnBottom: any
  componentDidMount() {
    const isMobile = window.matchMedia(
      '(min-width: 320px) and (max-width: 698px)'
    ).matches
    this.setState({ isMobile })
  }

  toggleDesignAnimation = () => {
    this.setState({ designCardFolded: !this.state.designCardFolded })
    setTimeout(() => this.scrollToDesign(), 700)
  }

  toggleProDesignAnimation = () => {
    this.setState({ proDesignCardFolded: !this.state.proDesignCardFolded })
    setTimeout(() => this.scrollBottom(), 700)
  }

  scrollBottom = () => {
    if (window) {
      const node = document.querySelector('.ant-modal-wrap')
      if (node) {
        const modalScroller = zenscroll.createScroller(node, 0)
        modalScroller.toY(node.scrollHeight)
      }
    }
  }

  scrollToDesign = () => {
    if (window) {
      const node = document.querySelector('.ant-modal-wrap')
      if (node) {
        const modalScroller = zenscroll.createScroller(node, 0)
        modalScroller.center(this.btnBottom)
      }
    }
  }

  render() {
    // const { designCardFolded, proDesignCardFolded, isMobile } = this.state
    const {
      goToCustomize,
      goToProDesign,
      // openForm,
      hideCustomize = false,
      open,
      onClose
    } = this.props

    return (
      <Modal
        visible={open}
        footer={null}
        width="890px"
        closable={false}
        maskClosable={true}
        destroyOnClose={true}
        wrapClassName="transparent-modal-only"
        onCancel={onClose}
      >
        <InlineContainer>
          {!hideCustomize &&
            <Card onClick={goToCustomize}>
              <CardTitle>
                <img src={DesignCenterBanner} />
              </CardTitle>
              <DescriptionDiv
                dangerouslySetInnerHTML={{
                  __html: `<p><strong>Looking to explore new design trends, experiment with colors, logos, and layouts?
                  </strong></p> <p><strong>DesignLab</strong> is ideal for those who enjoy designing their own kits. 
                  Explore our library of Kickstart designs and experiment with colors, logos 
                  and art to create your one-of-a-kind kit.
                  </p>`
                }}
              />
              <List>
                <Item>
                  Fastest design and ordering process.
                </Item>
              </List>
              <ButtonWrapper>
                <Button>
                  <ColorWheel src={colorWheel} />
                  START YOUR DESIGN
                </Button>
              </ButtonWrapper>

            </Card>
          }
          <Card onClick={goToProDesign}>
            <CardTitle>
              <img src={ProDesignBanner} />
            </CardTitle>
            <DescriptionDiv
              dangerouslySetInnerHTML={{
                __html: `<p><strong>Have clear ideas of what you want but need a Pro Designer to put them all together.
                </strong></p> <p><strong>Pro Design</strong> is the best option for those who have clear design 
                instructions and all their team or sponsor logo artwork ready to send to our design team.</p>`
              }}
            />
            <List>
              {proDesignMessages.map((item: string, index: number) => (
                <Item
                  key={index}
                >
                  Dedicated Account Manager to assist with design and ordering.
                </Item>
              ))}
            </List>
            <ButtonWrapper>
              <Button>
                <ColorWheel src={colorWheel} />
                START YOUR DESIGN
              </Button>
            </ButtonWrapper>
          </Card>
        </InlineContainer>
      </Modal>
    )

    // return (
    //   <CustomModal
    //     {... { open }}
    //     withLogo={false}
    //     width={'100%'}
    //     requestClose={onClose}
    //     style={{ maxWidth: '888px', padding: '0 18px', top: isMobile ? 'unset' : '18px' }}
    //     wrapClassName={isMobile && 'transparent-modal'}
    //     withCross={!isMobile}
    //     maskStyle={isMobile && { background: 'rgba(0,0,0,0.9)' }}
    //   >
    //     <Title>{formatMessage(messages[hideCustomize ? 'oneWay' : 'twoWays'])}</Title>
    //     {isMobile ?
    //       (<MobileContainer>
    //         <CloseIcon src={closeIcon} onClick={onClose} />
    //         <UnfoldList childrens={[]} />
    //         {!hideCustomize &&
    //           <UnfoldContainer>
    //             <BannerBack onClick={this.toggleDesignAnimation}>
    //               <Banner src={DesignCenterBanner} />
    //             </BannerBack>
    //             <FoldContent
    //               order={1}
    //               className={designCardFolded ? 'folded' : 'unfolded'}
    //             >
    //               <MobileCard>
    //                 <DescriptionDiv
    //                   dangerouslySetInnerHTML={{
    //                     __html: formatMessage(messages.descriptionDesign)
    //                   }}
    //                 />
    //               </MobileCard>
    //             </FoldContent>
    //             <div ref={btn => { this.btnBottom = btn }} />
    //             <FoldContent
    //               order={2}
    //               className={designCardFolded ? 'folded' : 'unfolded'}
    //               onClick={goToCustomize}
    //             >
    //               <ButtonWrapper onClick={goToCustomize}>
    //                 <Button>
    //                   <ColorWheel src={colorWheel} />
    //                   {formatMessage(messages.customizeLabel)}
    //                 </Button>
    //               </ButtonWrapper>
    //             </FoldContent>
    //           </UnfoldContainer>
    //         }
    //         <UnfoldContainer>
    //           <BannerBack onClick={this.toggleProDesignAnimation}>
    //             <Banner src={ProDesignBanner} />
    //           </BannerBack>
    //           <FoldContent
    //             order={1}
    //             className={proDesignCardFolded ? 'folded' : 'unfolded'}
    //           >
    //             <MobileCard>
    //               <DescriptionDiv
    //                 dangerouslySetInnerHTML={{
    //                   __html: formatMessage(messages.descriptionPro)
    //                 }}
    //               />
    //             </MobileCard>
    //           </FoldContent>
    //           {proDesignMessages.map((item: string, index: number) => (
    //             <FoldContent
    //               key={index}
    //               order={index + 2}
    //               className={proDesignCardFolded ? 'folded' : 'unfolded'}
    //             >
    //               <MobileCard>
    //                 <SimpleLi message={formatMessage(messages[item])} />
    //               </MobileCard>
    //             </FoldContent>
    //           ))}
    //           <FoldContent
    //             order={proDesignMessages.length + 2}
    //             className={proDesignCardFolded ? 'folded' : 'unfolded'}
    //             onClick={goToProDesign}
    //           >
    //             <ButtonWrapper>
    //               <Button>
    //                 <ColorWheel src={colorWheel} />
    //                 {formatMessage(messages.customizeLabel)}
    //               </Button>
    //             </ButtonWrapper>
    //           </FoldContent>
    //         </UnfoldContainer>
    //       </MobileContainer>) :
    //       <DesignsCardsContainer>
    //         {!hideCustomize &&
    //           <Card onClick={goToCustomize}>
    //             <CardTitle>
    //               <img src={DesignCenterBanner} />
    //             </CardTitle>
    //             <DescriptionDiv
    //               dangerouslySetInnerHTML={{
    //                 __html: formatMessage(messages.descriptionDesign)
    //               }}
    //             />
    //             <ButtonWrapper>
    //               <Button>
    //                 <ColorWheel src={colorWheel} />
    //                 {formatMessage(messages.customizeLabel)}
    //               </Button>
    //             </ButtonWrapper>

    //           </Card>
    //         }
    //         <Card onClick={goToProDesign}>
    //           <CardTitle>
    //             <img src={ProDesignBanner} />
    //           </CardTitle>
    //           <DescriptionDiv
    //             dangerouslySetInnerHTML={{
    //               __html: formatMessage(messages.descriptionPro)
    //             }}
    //           />
    //           <List>
    //             {proDesignMessages.map((item: string, index: number) => (
    //               <Item
    //                 key={index}
    //               >
    //                 {formatMessage(messages[item])}
    //               </Item>
    //             ))}
    //           </List>
    //           <ButtonWrapper>
    //             <Button>
    //               <ColorWheel src={colorWheel} />
    //               {formatMessage(messages.customizeLabel)}
    //             </Button>
    //           </ButtonWrapper>
    //         </Card>
    //       </DesignsCardsContainer>}
    //       <AdditionalDiv>
    //         <OrText>OR</OrText>
    //         <BottomDescription
    //           dangerouslySetInnerHTML={{
    //             __html: formatMessage(messages.additionalDesc)
    //           }}
    //         />
    //         <RequestMore onClick={openForm}>{formatMessage(messages.requestMoreInfo)}</RequestMore>
    //       </AdditionalDiv>
    //   </CustomModal>
    // )
  }
}

export default StartDesignModal



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/TeamCustomModalWidget/index.tsx